import { z } from 'zod';

// #62: Opt-in KI-Briefing auf dem Rollen-Dashboard (#61). Ein LLM formuliert aus den SCHON
// berechneten Dashboard-Aggregaten 2-3 Sätze Klartext-Handlungsempfehlung. Es erfindet KEINEN
// neuen Fakt — es priorisiert/formuliert nur die schon sichtbaren Zahlen. Ehrlicher Degrade auf
// null ohne Gateway (wie AI-G/forecast).

// Ergebnis-Vertrag des Briefings: genau ein deutscher Klartext.
export interface RoleBriefing {
  text_de: string;
}

// Request-Body des Endpunkts: die schon berechneten Aggregate der aktuellen Rolle. ALLE optional —
// je nach Rolle sind nur einige Karten (und damit Zahlen) sichtbar. Die ROLLE ist bewusst NICHT
// Teil des Bodys: sie wird serverseitig aus dem eingeloggten Nutzer abgeleitet, nicht client-diktiert.
// Obergrenze für die Zahlen (kein Projekt hat so viele Testfälle/Defects) — verhindert absurde
// Werte, die ein Client sonst ungeprüft ins LLM-Prompt schieben könnte. go_no_go ist ein Enum, kein
// Freitext: die Prompt-Injection-Fläche bleibt minimal (der Guardrail-Filter greift zusätzlich).
const count = () => z.number().int().nonnegative().max(1_000_000).optional();
export const DashboardBriefingRequestSchema = z.object({
  open_runs: count(),
  pending_signoffs: count(),
  unassigned: count(),
  go_no_go: z.enum(['go', 'no_go']).optional(),
  blockers: count(),
  assigned_defects: count(),
  reported_defects: count(),
  // Review-Fund 2 (Whole-Branch-Review, 2026-09-10): seit dem Knoten-Filter (docs/requirements.md
  // §5) beziehen sich go_no_go/blockers/pending_signoffs/unassigned bei einer scope-gebundenen
  // Rolle auf ihren Struktur-Knoten, open_runs/assigned_defects/reported_defects bleiben dagegen
  // projektweit (Stufe 1, Issue #120). Ohne dieses Signal formuliert das LLM aus zwei fachlich
  // verschiedenen Grundmengen einen Satz, als wären es dieselben Zahlen. Bewusst ein BOOLEAN, kein
  // Freitext-Knotenname — dieselbe Minimal-Fläche wie `go_no_go` als Enum (Prompt-Injection bleibt
  // so klein wie möglich, s. permissions.ts/DashboardBriefingRequestSchema-Kommentar oben).
  scope_active: z.boolean().optional(),
});
export type DashboardBriefingRequest = z.infer<typeof DashboardBriefingRequestSchema>;

// Antwort des Endpunkts: der Briefing-Text oder null (ehrlicher Degrade ohne Gateway).
export interface DashboardBriefingResponse {
  text: string | null;
}
